import Vue from 'vue'
import { VCol, VContainer, VImg, VRow, VCard, VCardTitle, VCardText, VDivider } from 'vuetify/lib'
import './LoginError.scss'

export const LoginError = Vue.component('LoginError', {
	name: 'LoginError',

	render() {
		return (
			<VContainer class="login-error-container">
				<VRow>
					<VCol>
						<VImg src="/vectors/icon-no-connection.svg" height="320" contain />
					</VCol>
					<VCol>
						<VCard>
							<VCardTitle>Eita!</VCardTitle>
							<VCardText>Parece que seu acesso ao iSolve não foi permitido.</VCardText>
							<VDivider />
							<VCardText>Se você é novo por aqui, fale com seu consultor responsável.</VCardText>
							<VCardText>
								Caso você já tenha acessado o iSolve antes,{' '}
								<a
									href="https://docs.google.com/forms/d/e/1FAIpQLSdLlzXTWQj-tsDC8hbSfrV1fXWrGdOt06VZhs7Wn_JRaNLzow/viewform?usp=preview"
									target="_blank"
								>
									clique aqui
								</a>{' '}
								para te ajudarmos com seu acesso.
							</VCardText>
							<VCardText>
								Caso você seja um funcionário do QuintoAndar, entre pelo link{' '}
								<a href="https://isolve-internal.quintoandar.com.br" target="_blank">
									isolve-internal.quintoandar.com.br
								</a>
							</VCardText>
						</VCard>
					</VCol>
				</VRow>
			</VContainer>
		)
	}
})

export default LoginError
